// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/* .tr {\r\n  border-bottom: none;\r\n  border-top: none;\r\n} */\n#payments-table {\r\n  margin-top: 2rem;\n}\n#amounts-table > tbody > tr:last-child {\r\n  font-weight: bold;\r\n  padding-top: 1rem !important;\n}\n.text-align-left {\r\n  text-align: left;\n}\r\n", ""]);
// Exports
module.exports = exports;
